import { create } from "zustand"

interface ShowBalanceState {
  showBalance: boolean
  setShowBalance: (showBalance: boolean) => void
  showTotalEarn: boolean
  setShowTotalEarn: (showTotalEarn: boolean) => void
}

export const useShowBalance = create<ShowBalanceState>((set) => ({
  showBalance: false,
  showTotalEarn: false,
  setShowTotalEarn: (showTotalEarn) => set({ showTotalEarn }),
  setShowBalance: (showBalance) => set({ showBalance })
}))
